/* global analytics */
import React, { Component } from "react";
import Helmet from "react-helmet";

export default class ShareTwitter extends Component {

    handleClick = () => {
        analytics.track('Clicked Element', {
            element_name: 'Twitter Share'
        });
    }

    buildMessageForTweet = (isSharedBox, firstName) => {
        let baseUrl = "https://twitter.com/intent/tweet";
        let encodedShareUrl = encodeURIComponent(this.props.url);
        let message = isSharedBox ? `Check out what ${firstName} got in their box FabFitFun Box!` : encodeURIComponent("Check out what I got in my FabFitFun Box!");
        let finalUrl = `${baseUrl}?url=${encodedShareUrl}&text=${message}`;
        return finalUrl;
    }
    render(){
        const { isSharedBox, firstName } = this.props;
        return (
            <React.Fragment>
                <Helmet>
                    <script src="https://platform.twitter.com/widgets.js" id="twitter-wjs"></script>
                </Helmet>
                <a className="smb__twitter-link" href={this.buildMessageForTweet(isSharedBox, firstName)} onClick={this.handleClick}>
                    <div 
                        className="smb__icon smb__icon--twitter smb__icon--no-margin" 
                        title="Share on Twitter"
                    >
                        <i className="fab fa-twitter"></i>
                    
                    </div>
                </a>
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/ShareMyBox/ShareTwitter/ShareTwitter.js